import { useEffect } from "react";
import { Provider as ThemeProvider } from "@remo-co/ui-core/src/components/Provider";
import { RemoTheme } from "@remo-co/ui-core/theme";
import { useAppDispatch } from "store/hooks";
import { useSelector } from "react-redux";
import BroadcasterSubscriber from "modules/broadcaster/BroadcasterSubscriber";
import BroadcastWhiteboardSubscriber from "modules/broadcastWhiteboard/BroadcastWhiteboardSubscriber";
import { TopBar } from "modules/topBar";
import { DisplayLayout } from "modules/audioVideo";
import { updateActiveChannel } from "modules/chat/redux/actions";
import { selectCurrentTheaterId } from "modules/theater/selectors";
import { setLayout } from "modules/audioVideo/redux/slice";
import { AudioReactions } from "modules/audioReactions";
import { StyledEngineProvider } from "@remo-co/ui-core/src/components/StyledEngineProvider";
import { selectIsMeBroadcaster } from "modules/broadcaster";
import BroadcastVideoSubscriber from "./BroadcastVideoSubscriber";
import { BroadcastDefaultView } from "./components";
import BroadcastLayout, { Panels } from "./layout/BroadcastLayout";
import "./BroadcastContainer.scss";
import * as actions from "../chat/redux/actions";
import BroadcastMenu from "./menu/BroadcastMenu";

const BroadcastContainer = (): JSX.Element | null => {
  const theaterId = useSelector(selectCurrentTheaterId);
  const isMeBroadcaster = useSelector(selectIsMeBroadcaster);
  const dispatch = useAppDispatch();
  const classNames = ["broadcast-container"];

  if (isMeBroadcaster) {
    classNames.push("broadcaster");
  }

  useEffect(() => {
    dispatch(setLayout(DisplayLayout.Tile));
    dispatch(actions.updateActiveChannel(theaterId));

    return () => {
      dispatch(updateActiveChannel(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!theaterId) {
    return null;
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={RemoTheme.dark}>
        <BroadcastLayout>
          <div className={classNames.join(" ")}>
            <Panels>
              <TopBar />
              <BroadcastDefaultView />
              <BroadcastMenu />
            </Panels>
          </div>
        </BroadcastLayout>
        <BroadcasterSubscriber theaterId={theaterId} />
        <BroadcastVideoSubscriber />
        <BroadcastWhiteboardSubscriber />
        <AudioReactions />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default BroadcastContainer;
